export default "__VITE_ASSET__DNUM7lVC__"